module.exports = __webpack_public_path__ + "static/img/aepic-28.5f102a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-28.jpg
// module id = rZSL
// module chunks = 52